import React, { Fragment, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Box } from 'components/Layout/Layout';
import { FormattedMessage, useIntl } from 'react-intl';
import FormattedHtmlMessage from 'components/Intl/FormattedHtmlMessage';
import { ROUTE_ANALYSE_SELECT, ROUTE_ANALYSE_VIDEO } from 'RouteList';
import styled from 'styled-components';
import YoutubeEmbedVideo from 'youtube-embed-video';
import { useNavigate } from 'react-router-dom';

import Button from 'components/Button/Button';
import { paragraphStyle, H2Style } from 'components/P/textStyle';

import messages from './messages';
import { ANALYSE_BUILDING_BLOCKS } from '../../constants';
import { QUERY_GET_ANALYSE } from '../../services/graphql/video-analyse-query';
import P from '../../components/P/P';
import { useQuery } from '@apollo/client';

const HTMLWrapper = styled.div`
  padding-left: 20px;
  padding-right: 20px;

  h2 {
    ${H2Style};
    color: ${props => props.theme.colors.primary};
    margin-top: 1rem;
    margin-bottom: 1.5rem;
    line-height: 1.1;
  }

  p {
    ${paragraphStyle};
    font-family: ${props => props.theme.fonts.fontfaceBeta};
    line-height: 1.35;
    color: ${props => props.theme.colors.black};
    font-size: ${props => props.theme.fonts.sizeBase};
    margin-bottom: 1.25rem;
    max-width: 55rem;
  }
`;

const findItemById = (list, id) => {
  let result = null;
  list.forEach(data => {
    data.data.forEach(items => {
      const buildingBlock = items.items.find(item => item.id === id);
      if (buildingBlock) {
        result = buildingBlock;
      }
    });
  });
  return result;
};

function InfoPage({ analyseId, videoAnalyseId }) {
  const intl = useIntl();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const goBack = () => {
    navigate(`${ROUTE_ANALYSE_SELECT}/${videoAnalyseId}/${analyseId}`);
  };

  const gotoVideoPage = () => {
    navigate(`${ROUTE_ANALYSE_VIDEO}/${videoAnalyseId}/${analyseId}`);
  };

  const { loading, error, data } = useQuery(QUERY_GET_ANALYSE, {
    variables: { analyseId },
    fetchPolicy: 'cache-and-network'
  });

  if (loading) return <P>Bezig met laden...</P>;
  if (error) return <P danger>{error.message}</P>;

  const analyse = data?.getAnalyse;
  if (!analyse) {
    return <P danger>{intl.formatMessage(messages.analiseErrorLoading)}</P>;
  }

  return (
    <HTMLWrapper>
      {analyse.buildingBlocks.map(bb => {
        const buildingBlock = findItemById(ANALYSE_BUILDING_BLOCKS, bb);
        return (
          <Fragment key={bb}>
            <h2>{buildingBlock?.label?.toUpperCase?.() || ''}</h2>
            <div style={{ marginBottom: 30 }}>
              <YoutubeEmbedVideo
                size="medium"
                suggestions={false}
                showInfo={false}
                videoId={intl.formatMessage(messages['analyseInfoVideo' + bb])}
              />
            </div>
            <FormattedHtmlMessage
              id={messages['analyseInfoBlock' + bb].id}
              defaultMessage={messages['analyseInfoBlock' + bb].defaultMessage}
            />
          </Fragment>
        );
      })}

      <Box width={1} mt={2}>
        <Button
          primary
          disabled={loading}
          onClick={goBack}
          style={{ marginRight: 8 }}
        >
          <FormattedMessage {...messages.analyseInfoBackButton} />
        </Button>
        {analyse.buildingBlocks.length > 0 && (
          <Button primary onClick={gotoVideoPage}>
            <FormattedMessage {...messages.analyseInfoButton} />
          </Button>
        )}
      </Box>
    </HTMLWrapper>
  );
}

export default observer(InfoPage);
